import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DxService} from "../../../services/dx.service";
import {ServerService} from "../../../services/server.service";
import {DxDataGridComponent} from "devextreme-angular";
import {ActivatedRoute} from "@angular/router";
import {DialogService} from "../../../components/generics/dialog/dialog.service";
import {ProdottoVariante, ProdottoVarianteFactory} from "../../../models/ProdottoVariante";

@Component({
   selector: 'app-prodotti-varianti',
   templateUrl: './prodotti-varianti.component.html',
   styleUrls: ['./prodotti-varianti.component.scss']
})
export class ProdottiVariantiComponent implements OnInit, AfterViewInit {
   @ViewChild('grid') grid!:DxDataGridComponent;
   @Input() isModal = false;
   @Input() isVendor = false;
   @Input() isPVendita = false;
   @Input() vendorSlug;
   @Input() pVenditaID;
   @Input() pVariant;
   @Input() pVariantIds:number[] = [];
   @Input() excludeNotOrdered = false;
   @Output() eventEmitter = new EventEmitter<any>();
   // public vendorSlug;

   constructor(private dxSrv: DxService,
               private route: ActivatedRoute,
               private dialogSrv: DialogService,
               private prodottoVarianteFctr: ProdottoVarianteFactory,
               private serverSrv: ServerService) {
      if (!this.vendorSlug)
         this.vendorSlug = this.route.parent?.parent?.snapshot.paramMap.get('esercizio_slug')
   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.dxSrv.initGrid(this.grid, {})
      let url = this.isVendor
         ? `/api/esercizi/${this.vendorSlug}/productvariants`
         : `/api/productvariants`

      if (this.pVariant){
         url += `?prodotto=${this.pVariant.data.prodotto.data.id}&exclude=${this.pVariantIds}`
      }

      this.dxSrv.gridCreateDataSource(url, this.grid, {
         filter: {
            pVenditaID: this.pVenditaID,
            excludeNotOrdered: this.excludeNotOrdered
         },
         onLoaded: rawData => {
            console.log("rawDatarawData")
            console.log(rawData)
         }
      })
   }

   clickApprovaVariante(prodottoVariante) {
      this.dialogSrv.showConfirm({title:"Approva variante", msg:"Vuoi approvare la variante?"}).then(()=> {
         this.prodottoVarianteFctr.approvaProdottoVariante(prodottoVariante.data.prodotto.id, prodottoVariante.data.id).then(res => {
            this.dialogSrv.showToastSuccess({title:'Approvazione variante', msg:"Variante modificata"})
            this.grid.instance.refresh()
         }).catch(err => {
            console.error(err)
            this.dialogSrv.showError({title:"Attenzione!", err:err})
         })
      }).catch(err => {})
   }

   openLink(url){
      return this.serverSrv.getPrivateMedia(url)
   }

   clickSelectVariant(pVariant) {
      this.eventEmitter.emit(pVariant);
   }

   clickEliminaVariante(variante) {
      this.dialogSrv.showConfirm({title:"Elimina variante-colore", msg:"Vuoi davvero eliminare questa variante-colore?"}).then(() => {
         this.prodottoVarianteFctr.deleteProdottoVariante(variante.data.prodotto.id, variante.data.id, this.vendorSlug).then(res => {
            this.dialogSrv.showSuccess({title:"Cancella variante", msg:"Variante eliminata"})
            this.grid.instance.refresh()
         }).catch(err => {
            console.error(err)
         })
      }).catch(err => {})
   }
}
